import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import i18n from '@/i18n';
import elementLocal from 'element-ui/lib/locale'
elementLocal.i18n((key, value) => i18n.t(key, value)); // element-ui获取语言
// 定义全局组件：在入口文件注册一次之后，在任何组件当中都可以使用
// import {
//   Avatar,
//   Row,
//   Col,
//   Button,
//   Empty,
//   Input,
//   Table,
//   TableColumn,
//   Select,
//   Card,
//   Option,
//   Checkbox,
//   CheckboxButton,
//   CheckboxGroup,
//   Form,
//   FormItem,
//   PageHeader,
//   Pagination,
//   Popover,
//   Radio,
//   RadioGroup,
//   RadioButton,
//   Message,
//   MessageBox,
//   Link,
//   Loading,
//   Dropdown,
//   DropdownMenu,
//   DropdownItem,
//   Carousel,
//   CarouselItem,
//   Upload,
//   Image,
//   Divider,
//   Tag,
//   Tabs,
//   TabPane,
//   Tooltip,
//   Dialog,
//   DatePicker,
//   Switch,
//   Progress,
//   Cascader,
// } from 'element-ui';
import Element from 'element-ui'

import './assets/element/index.css';
import MetaInfo from 'vue-meta-info'; // 导入页面SEO插件
Vue.use(MetaInfo)
import VForm from 'vform-builds' // 引入VForm库
import 'vform-builds/dist/VFormDesigner.css' // 引入VForm样式
Vue.use(VForm) // 全局注册VForm(同时注册了v-form-designer和v-form-render组件)
// 重置样式
import './assets/css/reset.css';
import './assets/css/common.css';

// 扩展ElmentUI的Pagination组件，添加一个方法，当页码改变的时候，让页面滚动到顶部
const functionAfter = function(targetFn, afterFn) {
  return function() {
    const res = targetFn.apply(this, arguments);
    afterFn.apply(this, arguments);
    return res;
  };
}
Element.Pagination.methods.emitChange = functionAfter(Element.Pagination.methods.emitChange, function() {
  document.documentElement.scrollTop = 0;
});

Vue.config.productionTip = false
// Vue.use(Avatar);
// Vue.use(Row);
// Vue.use(Col);
// Vue.use(Button);
// Vue.use(Empty);
// Vue.use(Input);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(Select);
// Vue.use(Card);
// Vue.use(Option);
// Vue.use(Checkbox);
// Vue.use(CheckboxButton);
// Vue.use(CheckboxGroup);
// Vue.use(Form);
// Vue.use(FormItem);
// Vue.use(PageHeader);
// Vue.use(Pagination);
// Vue.use(Popover);
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(RadioButton);
// Vue.use(Link);
// Vue.use(Loading.directive);
// Vue.use(Dropdown);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Carousel);
// Vue.use(CarouselItem);
// Vue.use(Upload);
// Vue.use(Image);
// Vue.use(Divider);
// Vue.use(Tag);
// Vue.use(Tabs);
// Vue.use(TabPane);
// Vue.use(Tooltip);
// Vue.use(Dialog);
// Vue.use(DatePicker);
// Vue.use(Switch);
// Vue.use(Progress);
// Vue.use(Cascader);
Vue.use(Element)
Vue.prototype.$loading = Element.Loading.service;
Vue.prototype.$message = Element.Message;
Vue.prototype.$confirm = Element.MessageBox.confirm;
// 引入swiper样式
import "swiper/css/swiper.css";
// 如果生产环境想用mock数据，放开下面注释
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
// 引入表单校验插件
import "@/plugins/validate";

// 引入vconsole插件
// import Vconsole from 'vconsole'
// if (process.env.NODE_ENV !== 'prod') {
//   const vConsole = new Vconsole()
//   Vue.use(vConsole)
// }

// 引入移动端日期组件
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);

const ua = window.navigator.userAgent.toLowerCase();
// 如果用户使用IE浏览器访问，提示用户使用其他浏览器
if (ua.indexOf('msie') > 0 || ua.indexOf('trident') > 0) {
  const targetNode = document.getElementById('app');
  const tipNode = document.createElement('div');
  tipNode.innerHTML = `
    <div style="width: 100%; height: 100vh; background-color: #fff; display: flex; justify-content: center; align-items: center;">
      <div style="width: 1200px; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <h1 style="font-size: 28px; color: #333; margin-bottom: 20px;">您的浏览器版本过低，请使用其他浏览器访问</h1>
        <div style="font-size: 18px; color: #333;">推荐使用以下浏览器：</div>
        <div style="width: 600px; display: flex; justify-content: space-around; align-items: center; margin-top: 80px;">
          <a href="https://www.google.cn/chrome/" target="_blank" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <img src="http://pic.uzzf.com/up/2021-6/2021618913361686.png" style="width: 50px; height: 50px; border-radius: 50%; margin-bottom: 10px;" />
            <div style="font-size: 14px; color: #333;">谷歌浏览器</div>
          </a>
          <a href="http://www.firefox.com.cn/" target="_blank" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <img src="http://pic.uzzf.com/up/2017-1/201714109184012.jpg" style="width: 50px; height: 50px; border-radius: 50%; margin-bottom: 10px;" />
            <div style="font-size: 14px; color: #333;">火狐浏览器</div>
          </a>
          <a href="https://www.microsoft.com/zh-cn/edge" target="_blank" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <img src="http://pic.uzzf.com/up/2022-7/2022781145393180.png" style="width: 50px; height: 50px; border-radius: 50%; margin-bottom: 10px;" />
            <div style="font-size: 14px; color: #333;">Edge浏览器</div>
          </a>
        </div>
      </div>
    </div>
  `;
  targetNode.appendChild(tipNode);
} else {
  new Vue({
    render: (h) => h(App),
    store,
    router,
    i18n
  }).$mount("#app");
}
